import { searchFiltersFactory } from '@rover/react-lib/src/factories/searchFiltersFactory';
import type {
  ActionCreator,
  Duck,
  DuckOptions,
  EffectCreator,
} from '@rover/react-lib/src/lib/redux-duck';
import { createDuck } from '@rover/react-lib/src/lib/redux-duck';
import type { SearchFiltersSelectors } from '@rover/react-lib/src/pages/search/SearchPage/SearchFilters.duck';
import {
  options as searchFilters,
  selectors as searchFiltersSelectors,
} from '@rover/react-lib/src/pages/search/SearchPage/SearchFilters.duck';
import type { SearchFilters } from '@rover/types';

export type State = {
  filters: SearchFilters;
  didFiltersChangeSincePageLoad: boolean;
  isDirty: boolean;
};
type Actions = {
  filtersUpdated: ActionCreator<{
    filters: Partial<SearchFilters>;
  }>;
};
type Effects = {
  initialize: EffectCreator<void>;
  updateFilters: EffectCreator<Partial<SearchFilters>>;
};
type Selectors = SearchFiltersSelectors;
type Options = DuckOptions<State, Actions, Effects, Selectors>;
const {
  getFilters,
  getIsCatOnly,
  getLocationFilter,
  getPetTypeBrowsableServiceTypeOptions,
  getServiceTypeFilter,
  getServiceTypeFilterOptions,
} = searchFilters.selectors;
export const options: Options = {
  name: 'searchModal',
  initialState: {
    filters: searchFiltersFactory(),
    didFiltersChangeSincePageLoad: false,
    isDirty: false,
  },
  actions: {
    filtersUpdated:
      ({ filters }) =>
      (state) => ({ ...state, filters: { ...state.filters, ...filters } }),
  },
  effects: {
    initialize:
      () =>
      async (dispatch, getState, { filtersUpdated }) => {
        const initialFilters = searchFiltersSelectors.getFilters(getState());

        if (initialFilters) {
          await dispatch(
            filtersUpdated({
              filters: initialFilters,
            })
          );
        }
      },
    updateFilters:
      (filters) =>
      async (dispatch, getState, { filtersUpdated }) => {
        await dispatch(
          filtersUpdated({
            filters,
          })
        );
      },
  },
  selectors: {
    // Copying selectors from SearchFilters duck
    // @ts-expect-error
    getFilters,
    // @ts-expect-error
    getLocationFilter,
    // @ts-expect-error
    getIsCatOnly,
    // @ts-expect-error
    getPetTypeBrowsableServiceTypeOptions,
    // @ts-expect-error
    getServiceTypeFilter,
    // @ts-expect-error
    getServiceTypeFilterOptions,
  },
};
export const { actions, selectors, effects, reducer } = createDuck(options) as Duck<
  State,
  Actions,
  Effects,
  Selectors
>;
